export const cacheResultForEventsKey = 'events-dateToEventsWithGroups';
export const cacheResultForTimesheetsKey = 'timesheets-dateToTimesheet';

export const cacheResultForViewsFilterOptionsKey = (host: string) =>
  `views-filterOptions-${host}`;
